import { useTranslation } from "react-i18next";
import { EmptyState } from "@/shared/components";
import { useProjectTablePage } from "../../hooks/useProjectTablePage";
import { ProjectTableHeader, ProjectTableContent, ProjectTableSkeleton } from "./components";

export default function ProjectTablePage() {
  const { t } = useTranslation("ProjectTablePage");
  const {
    projects,
    isLoading,
    isError,
    isEmpty,
    dateRange,
    onDateRangeChange,
    handleDownload,
    isExporting,
    locale,
  } = useProjectTablePage();

  return (
    <>
      <title>{t("meta.title")}</title>
      <section className="flex-1">
        <ProjectTableHeader
          onExport={handleDownload}
          isExporting={isExporting}
          disabled={isLoading || isEmpty}
          dateRange={dateRange}
          onDateRangeChange={onDateRangeChange}
          locale={locale}
        />
        <div className="radius-3xl surface-base-fill p-7">
          {isLoading ? (
            <ProjectTableSkeleton />
          ) : isError ? (
            <EmptyState noDataText={t("error.title")} noDataHint={t("error.description")} />
          ) : isEmpty ? (
            <EmptyState noDataText={t("empty.title")} noDataHint={t("empty.description")} />
          ) : (
            <ProjectTableContent projects={projects} />
          )}
        </div>
      </section>
    </>
  );
}
